import React from "react";
import Popup from "devextreme-react/popup";
const EditSeedInventoryDialog = (props) => {
  const {
    openEditSeedInventoryDialog,
    openSeedInventory,
    closeEditSeedInventoryDialog,
  } = props;
  return (
    <div>
      <Popup
        visible={openSeedInventory}
        onHiding={closeEditSeedInventoryDialog}
        showCloseButton={false}
        dragEnabled={false}
        closeOnOutsideClick={true}
        title="Edit Seed Inventory"
        width="auto"
        height="auto"
        toolbarItems={[
          {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: {
              text: "Ok",
              onClick: closeEditSeedInventoryDialog,
              stylingMode: "contained",
              type: "default",
              elementAttr: {
                class: "accordianButton",
              }
            },
          },
        ]}
      >
        <h5 className="font-weight-bold">
        Your seed Inventory has been successfully edited.
        </h5>
      </Popup>
    </div>
  );
};

export default EditSeedInventoryDialog;
